import type { CompleteFieldSelector } from '@/types/fields-api.model';
import type { User } from '@/types/user.model';
import { RANKING_FIELDS } from '../sport/sport-fields.config';

const MANAGER_FIELDS_MINIMAL = {
  id: true,
  name: true,
  email: true,
} as const;

const MANAGER_FIELDS_BASIC = {
  ...MANAGER_FIELDS_MINIMAL,
  username: true,
  gender: true,
  birthdate: true,
  cellphone: true,
} as const;

const MANAGER_FIELDS_FULL: CompleteFieldSelector<User> = {
  ...MANAGER_FIELDS_BASIC,
  roles: true,
  phoneToken: true,
  hasMercadoPagoCredentials: true,
  rankings: RANKING_FIELDS.BASIC,
  playerSubscription: {
    id: true,
    subscriptionType: true,
    mercadoPagoSubscriptionId: true,
    subscriptionRole: true,
  },
  managerSubscription: {
    id: true,
    subscriptionType: true,
    mercadoPagoSubscriptionId: true,
    subscriptionRole: true,
  },
  profileImageUrl: true,
  termsAccepted: true,
} as const;

export const MANAGER_FIELDS = {
  MINIMAL: MANAGER_FIELDS_MINIMAL,
  BASIC: MANAGER_FIELDS_BASIC,
  FULL: MANAGER_FIELDS_FULL,
} as const;
